<template>
  <v-card class="success-card" width="100%">
    <v-app-bar flat dense color="white" class="px-0 pt-1" style="width: 100%;">
      <v-toolbar-title class="mx-0 px-0">{{ $t('PROGRAM.success_card.congratulations') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        icon
        fab
        small
        @click="close"
      >
        <v-icon>{{ mdiClose }}</v-icon>
      </v-btn>
    </v-app-bar>

    <v-card-text style="font-size: 1rem; padding: 0 16px; margin: 0;" class="pt-2">
      <strong class="event-title">
        {{ event ? event.content[$i18n.locale].title : '' }}<!--
      --></strong><!--
      -->{{ $t('PROGRAM.success_card.event_register_after') }}
    </v-card-text>

    <v-card-text class="event-info">
      <v-card flat class="event-local">
        <v-icon size="2.3rem" color="#1E88E5">{{ mdiMapMarker }}</v-icon>
        <span>{{ event && event.content[$i18n.locale].location }}</span>
      </v-card>
      <v-card flat class="event-date">
        <v-icon size="2.3rem" color="#1E88E5">{{ mdiCalendar }}</v-icon>
        {{ $translateDate(event ? event.schedule.day : new Date().toISOString().split('T')[0]) }}
      </v-card>
      <v-card flat class="event-time">
        <v-icon size="2.3rem" color="#1E88E5">{{ mdiClock }}</v-icon>
        {{ event && event.schedule.start }} - {{ event && event.schedule.end }} (GMT-3)
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mdiMapMarker, mdiClock, mdiCalendar, mdiClose } from '@mdi/js';

  export default {
    name: 'SuccessCard',
    props: {
      event: {
        type: Object,
        required: false,
        default: null
      }
    },
    data() {
      return {
        mdiMapMarker,
        mdiClock,
        mdiCalendar,
        mdiClose,
      }
    },
    methods: {
      close() {
        this.$emit('close');
      }
    }
  }
</script>

<style scoped>
  .event-local,
  .event-date,
  .event-time {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 32%;
    height: 140px;

    border: 1px solid #1E88E5;

    font-size: 1rem;
  }

  .event-local {
    font-size: 0.85rem;
    text-align: center;
  }

  .event-title {
    color: #1E88E5;
  }

  .v-card__text.event-info {
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    
    padding: 0 16px;
    padding-bottom: 20px;
    margin: 0;
    margin-top: 20px;
  }

  .v-card__text.event-info .v-icon {
    margin-bottom: 10px;
  }

  .event-local span {
    max-width: 80%;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  @media (max-width: 600px) {
    .event-local,
    .event-date,
    .event-time {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;

      width: 100%;
      height: 60px;

      padding: 0 10px;

      border: 1px solid #1E88E5;

      font-size: 1rem;
    }

    .v-card__text.event-info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      gap: 15px;

      width: 100%;

      margin-top: 20px;
    }

    .v-card__text.event-info .v-icon {
      margin-bottom: 0;
      margin-right: 4px;
    }

    .success-card >>> .v-toolbar__content {
    padding: 0 16px !important;
  }
  }
</style>